import { AppInfo } from "../models";
import { IMainLayoutAppsSubscriber, IUnsubscribeFunc, jituxCore } from "./jitux-core";
import { appStore } from "./app-store";

/***
 * Exposes functionalities to JITUX Apps
 */
export interface IJituxProxy {
  subscribeMainLayoutApps(subscriber: IMainLayoutAppsSubscriber): IUnsubscribeFunc;
  loadDashboard(clientDashboardId: number, signal?: AbortSignal): Promise<AppInfo[]>;
  getSelectedDashboardId(): number;
}

export class JituxProxy implements IJituxProxy {
  constructor(private currentApp: AppInfo) {}

  subscribeMainLayoutApps(subscriber: IMainLayoutAppsSubscriber): IUnsubscribeFunc {
    return jituxCore.subscribeMainLayoutApps(this.currentApp.id, subscriber);
  }

  async loadDashboard(clientDashboardId: number, signal?: AbortSignal): Promise<AppInfo[]> {
    if (signal?.aborted) {
      const error = new Error("Dashboard selection was canceled");
      error.name = "AbortError";
      throw error;
    }
    appStore.selectDashboard(clientDashboardId);
    return appStore.apps;
  }

  getSelectedDashboardId(): number {
    return appStore.clientDashboardId;
  }
}
